import * as React from "react"
import { cn } from "@/lib/utils"
import { getShortcutKey } from "../utils"

export interface ShortcutKeyProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  keys: string[]
}

/** Platform-aware shortcut symbols (⌘B, ⌥⇧7…), muted like DropdownMenuShortcut. */
export const ShortcutKey = React.forwardRef<HTMLSpanElement, ShortcutKeyProps>(
  ({ className, keys, ...props }, ref) => {
    const modifiedKeys = keys.map((key) => getShortcutKey(key))
    const ariaLabel = modifiedKeys
      .map((shortcut) => shortcut.readable)
      .join(" + ")

    return (
      <span
        aria-label={ariaLabel}
        className={cn(
          "inline-flex items-center gap-0.5 font-sans text-[11px] font-medium text-muted-foreground",
          className
        )}
        {...props}
        ref={ref}
      >
        {modifiedKeys.map((shortcut) => (
          <kbd
            key={shortcut.symbol}
            className="inline-block min-w-2.5 text-center align-baseline font-sans capitalize"
          >
            {shortcut.symbol}
          </kbd>
        ))}
      </span>
    )
  }
)

ShortcutKey.displayName = "ShortcutKey"
